export const contactsData = {
    email: 'work@olehkimaktelescopic.co.uk',
    phone: '+380989950687',
    address: 'Tkacka Lviv Lvivska OBL, Ukraine - 79019',
    sheetAPI: 'api/sendmessage',
    skype: 'live:.cid.b642896865f7a6ef',
    telegram: 'oleh_kimak'
}